export function GradientBackground() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background:
          'linear-gradient(to bottom, #020510 0%, #040c18 30%, #051025 60%, #061538 100%)',
        zIndex: -2,
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        pointerEvents: 'none', // Allow clicking through the background
      }}
    />
  );
}
